import { Carousel, LoopButton, Typography } from '@loophealth/loop-ui-web-library';
import React, { useState } from 'react';
import {
    StyledOnboardingScreenBottomBar,
    StyledOnboardingScreenCTA,
    StyledOnboardingScreenFtuxItem,
    StyledOnboardingScreenFtuxWrapper,
    StyledOnboardingScreenImage,
    StyledOnboardingScreenItemColumn,
    StyledOnboardingScreenItemHeader,
    StyledOnboardingScreenItemHeaderBadge,
    StyledOnboardingScreenItemHeaderBadgeWrapper
} from './styles';
import { IOnboardingScreenFtuxProps } from './types';
import { OnboardingScreenFtuxSteps } from './constants';
import useResponsive from '../PolicyInclusionsModal/hooks/useResponsive';

const OnboardingScreenFtux: React.FC<IOnboardingScreenFtuxProps> = ({ onClose }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const isDesktop = useResponsive('(min-width: 768px)');

    const totalSteps = OnboardingScreenFtuxSteps.length;
    const isLastStep = currentStep === totalSteps - 1;
    const currentStepItem = OnboardingScreenFtuxSteps[currentStep];

    const handleNextClick = () => {
        if (isLastStep) onClose();
        else setCurrentStep(currentStep + 1);
    };

    const handleBackClick = () => {
        setCurrentStep(currentStep - 1);
    };

    const renderCarousel = () => (
        <Carousel variant="points" steps={totalSteps} activeStep={currentStep} setStep={setCurrentStep} />
    );

    const renderCTA = () => (
        <StyledOnboardingScreenCTA data-testid="onboarding-ftux-cta">
            {currentStepItem.backButton && (
                <LoopButton variant="secondary" onClick={handleBackClick}>
                    Back
                </LoopButton>
            )}
            <LoopButton variant="filled" onClick={handleNextClick}>
                {currentStepItem.nextButtonText}
            </LoopButton>
        </StyledOnboardingScreenCTA>
    );

    return (
        <StyledOnboardingScreenFtuxWrapper data-testid="onboarding-screen-ftux">
            {!isDesktop ? (
                <StyledOnboardingScreenFtuxItem>
                    <StyledOnboardingScreenImage src={currentStepItem.image} data-testid="onboarding-ftux-image" />
                </StyledOnboardingScreenFtuxItem>
            ) : null}
            <StyledOnboardingScreenFtuxItem>
                <StyledOnboardingScreenItemHeader>
                    <StyledOnboardingScreenItemHeaderBadgeWrapper>
                        {currentStepItem.showBadge && (
                            <StyledOnboardingScreenItemHeaderBadge>
                                <Typography variant="extraSmall" weight="medium" color="emerald">
                                    👋 Welcome to Loop!
                                </Typography>
                            </StyledOnboardingScreenItemHeaderBadge>
                        )}
                        <StyledOnboardingScreenItemColumn>
                            {currentStepItem.title}
                            <Typography variant={isDesktop ? 'large' : 'small'}>{currentStepItem.subtitle}</Typography>
                        </StyledOnboardingScreenItemColumn>
                    </StyledOnboardingScreenItemHeaderBadgeWrapper>
                </StyledOnboardingScreenItemHeader>
                {isDesktop ? (
                    <StyledOnboardingScreenItemColumn data-testid="onboarding-ftux-carousel">
                        {renderCarousel()}
                        {renderCTA()}
                    </StyledOnboardingScreenItemColumn>
                ) : null}
            </StyledOnboardingScreenFtuxItem>
            {isDesktop ? (
                <StyledOnboardingScreenFtuxItem>
                    <StyledOnboardingScreenImage src={currentStepItem.image} data-testid="onboarding-ftux-image" />
                </StyledOnboardingScreenFtuxItem>
            ) : (
                <StyledOnboardingScreenBottomBar>
                    {renderCarousel()}
                    {renderCTA()}
                </StyledOnboardingScreenBottomBar>
            )}
        </StyledOnboardingScreenFtuxWrapper>
    );
};

export default OnboardingScreenFtux;
